module.exports = __webpack_public_path__ + "static/media/image 1.46ef6e63.png";